import React from "react";
import banner from "../../assets/images/trustworthy-about-banner.jpg";

const Terms = () => {
  return (
    <>
      <section className="inner-banner">
        <img src={banner} alt="About Us Banner" className="inner-banner-img" />
        <div className="inner-banner-content">
          <div className="container">
            <div className="inner-banner-content-in">
              <h1>Terms & Condition</h1>

              <p>
                Best Home Servicing Company for Household Repairs or Servicing
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="privacy py-5">
        <div className="container">
          {/* Heading */}
          <div className="row mb-4">
            <div className="col-12">
              <h1 className="mb-3 text-center fw-bold">Terms & Conditions</h1>
            </div>
          </div>

          {/* Content */}
          <div className="row">
            <div className="col-12">
              <p>
                Welcome to <strong>Sevasati</strong>!
              </p>

              <p>
                These terms and conditions outline the rules and regulations for
                using the Sevasati website and services. By accessing this
                website, we assume you accept these terms. Do not continue to
                use Sevasati if you do not agree with all the terms stated on
                this page.
              </p>

              <p>
                The terms “User”, “You”, and “Your” refer to anyone accessing
                the platform. “We”, “Our”, and “Us” refer to Sevasati.
              </p>

              <h3>Cookies</h3>
              <p>
                We use cookies to enhance user experience. By using Sevasati,
                you consent to the use of cookies in accordance with our Privacy
                Policy.
              </p>

              <h3>License</h3>
              <p>
                Unless otherwise stated, Sevasati owns the intellectual
                property rights for all material on this website. All rights are
                reserved.
              </p>

              <p>You must not:</p>
              <ul>
                <li>Republish material from Sevasati</li>
                <li>Sell or rent content from Sevasati</li>
                <li>Copy or duplicate website material</li>
                <li>Redistribute content without permission</li>
              </ul>

              <h3>User Comments & Content</h3>
              <p>
                Certain sections of the website may allow users to post comments
                or content. Sevasati does not pre-review comments and is not
                responsible for user-generated content.
              </p>

              <p>You agree that:</p>
              <ul>
                <li>You have the right to post the content</li>
                <li>The content does not violate any intellectual property</li>
                <li>The content is not offensive, illegal, or misleading</li>
              </ul>

              <h3>Hyperlinking to Our Content</h3>
              <p>
                Government agencies, search engines, and news organizations may
                link to our website without prior approval. Other organizations
                may request approval for linking.
              </p>

              <p>
                No use of Sevasati’s logo or branding is permitted without
                written permission.
              </p>

              <h3>iFrames</h3>
              <p>
                You may not create frames around our webpages that alter the
                visual appearance without prior permission.
              </p>

              <h3>Content Liability</h3>
              <p>
                We are not responsible for content appearing on third-party
                websites that link to Sevasati.
              </p>

              <h3>Your Privacy</h3>
              <p>
                Please refer to our <strong>Privacy Policy</strong> for details
                on how we collect and use personal information.
              </p>

              <h3>Reservation of Rights</h3>
              <p>
                We reserve the right to request removal of any links to our
                website and to update these terms at any time.
              </p>

              <h3>Disclaimer</h3>
              <p>
                To the maximum extent permitted by law, Sevasati excludes all
                warranties related to website use. We are not liable for any
                damages arising from the use of our services.
              </p>

              <p>
                As long as the website and services are provided free of charge,
                we will not be liable for any loss or damage of any nature.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Terms;
